<template>
    <div>
        <DatePicker v-on:date-change="dateChanged"></DatePicker>
        <div class="button-container">
            <button v-for="restaurant in restaurants" :key="restaurant.restaurantId"
                    class="mdl-button mdl-color--accent restaurant-button"
                    v-on:click="selectedRestaurant = restaurant"
                    :class="{'mdl-shadow--6dp': restaurant.restaurantId !== selectedRestaurant.restaurantId}">
                {{restaurant.name}}
            </button>
        </div>

        <div class="mdl-grid">
            <div class="mdl-cell mdl-cell--10-col mdl-cell--1-offset-desktop mdl-shadow--4dp card">
                <MenuEdit v-if="selectedRestaurant != null" :restaurant="selectedRestaurant" :day="day"></MenuEdit>
            </div>
        </div>
    </div>
</template>

<script>
    import MenuEdit from "../components/MenuEdit";
    import axios from "axios"
    import config from "../config"
    import DatePicker from "../components/widgets/DatePicker";
    import Vue from "vue"

    export default {
        name: "Administration",
        components: {DatePicker, MenuEdit},
        data: function () {
            return {
                id: 1,
                restaurants: Array,
                selectedRestaurant: null,
                day: this.today()
            }
        },
        methods: {
            load: function () {
                axios
                    .get(config.host + "/v1/restaurant/")
                    .then(response => {
                        this.restaurants = response.data;
                        this.selectedRestaurant = this.restaurants[0];
                    })
                    // eslint-disable-next-line no-console
                    .catch(reason => console.log(reason));
            },
            today: function () {
                return new Date().toISOString().substr(0, 10);
            },
            dateChanged: function (day) {
                Vue.set(this, "day", day);
            }
        },
        mounted() {
            this.load();
        }
    }
</script>

<style scoped>
    .button-container {
        display: table;
        margin: auto;
    }

    .restaurant-button {
        color: white;
        margin-right: 1em;
        margin-left: 1em;
    }

    .card {
        padding: 1em;
    }
</style>